import axios from 'axios'
import get from 'lodash.get'
import { createObservableInstance, } from 'axios-observable-request'
import { of, } from 'rxjs'

import localStorageConfig from '~/config/localStorageConfig'

export const customAxiosConfig = {
  baseURL: process.env.REACT_APP_WEBSERVICE_HOST,
}

export const customAxiosInstance = axios.create(customAxiosConfig)

customAxiosInstance.interceptors.request.use(
  config => {
    const authToken = localStorage.getItem(localStorageConfig.authToken)
    if (process.env.REACT_APP_USE_AUTHORIZATION_HEADER === 'true' && authToken)
      // eslint-disable-next-line no-param-reassign
      config.headers.Authorization = `Bearer ${authToken}`
    return config
  },
  error => Promise.reject(error),
)

const createObservableRequest = createObservableInstance(customAxiosInstance)

export const createRequest = (config, mockedData) =>
  mockedData && process.env.REACT_APP_MOCK_WS === 'true'
    ? of({ data: mockedData, })
    : createObservableRequest(config)

export const getResponseData = response => get(response, 'data')
export const getErrorData = response => get(response, 'response.data')
